import { useEffect, useState } from 'react';
import { CheckHealt } from '../services/HealtCheck/HealtCheck';
import { useDispatch, useSelector } from 'react-redux';
import { setServerStatus } from '../redux/search.slice';
const ServerStatus = () => {
  let status = localStorage.getItem('serverStatus');
  let isBackendWorking = useSelector(
    (state: any) => state.search.isBackendWorking
  );
  const [color, setColor] = useState<string>(
    status === 'true' && isBackendWorking === true
      ? 'orange'
      : status === 'true'
      ? 'green'
      : 'red'
  );
  const [isServerUp, setIsServerUp] = useState<string>('false');

  useEffect(() => {
    if (isBackendWorking && status === 'true') {
      setColor('orange');
    } else if (status === 'true') {
      setColor('green');
    } else {
      setColor('red');
    }
  }, [isBackendWorking, status]);

  const dispatch = useDispatch();
  // const checkServerStatus = async () => {
  //   try {
  //     const response = await CheckHealt();
  //     if (response.status === 200) {
  //       localStorage.setItem('serverStatus', `true`);
  //       dispatch(setServerStatus(true))
  //       let status =localStorage.getItem('serverStatus');

  //       if(status){
  //         setIsServerUp(status);

  //       }
  //     } else {
  //       localStorage.setItem('serverStatus', `false`);
  //       let status =localStorage.getItem('serverStatus');

  //       dispatch(setServerStatus(false))
  //       if(status){
  //         setIsServerUp(status);

  return (
    <div
      style={{
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        backgroundColor: color,
      }}
    />
  );
};

export default ServerStatus;
